(function () {
    "use strict";

    function signatureService($http, $q, $log, URL) {
        var that = this;

        that.signItemBox = signItemBox;
        that.signFileItem = signFileItem;
        that.itemBoxSignatureInfo = itemBoxSignatureInfo;
        that.fileItemSignatureInfo = fileItemSignatureInfo;
        that.getSignFileItemContent = getSignFileItemContent;

        /**
        * Applies signature to an itemBox
        * @param {int} idBox id of the box
        * @param {int} idItemBox id of the item box
        * @param {String} image signature image in base64 format
        * @param {object} info information about the signature
        * @param {object} params parameters signature
        * @returns {Promise} the id of the new doc's version
        */
        function signItemBox(idBox, idItemBox, image, info, params) {
            var url = URL.URL + "/api/signature/box/" + idBox + "/" + idItemBox + "/sign";

            var formData = new FormData();
            formData.append('sig', image);
            formData.append('details', JSON.stringify(info));
            formData.append('signparams', JSON.stringify(params));

            return $q(function (resolve, reject) {
                $http.post(url, formData, {
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined }
                }).success(function (result) {
                    resolve(result);
                }).error(function (error) {
                    $log.error("Cannot sign item box");
                    console.dir(error || undefined);
                    reject(error || undefined);
                });
            });
        }

        /**
        * Applies signature to an itemBox
        * @param {int} idFileContainer id of the box
        * @param {int} idFileItem id of the item box
        * @param {String} image signature image in base64 format
        * @param {object} info information about the signature
        * @param {object} params parameters signature
        * @returns {Promise} the id of the new doc's version
        */
        function signFileItem(idFileContainer, idFileItem, image, info, params) {
            var url = URL.URL + "/api/signature/docs/" + idFileContainer + "/" + idFileItem + "/sign";

            var formData = new FormData();
            formData.append('sig', image);
            formData.append('details', JSON.stringify(info));
            formData.append('signparams', JSON.stringify(params));

            return $q(function (resolve, reject) {
                $http.post(url, formData, {
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined }
                }).success(function (result) {
                    resolve(result);
                }).error(function (error) {
                    $log.error("Cannot sign file item");
                    console.dir(error);
                    reject(undefined);
                });
            });
        }

        /**
        * Applies signature to an itemBox
        * @param {int} idFileContainer id of the box
        * @param {int} idFileItem id of the item box
        * @param {String} image signature image in base64 format
        * @param {object} info information about the signature
        * @param {object} params parameters signature
        * @returns {Promise} the id of the new doc's version
        */
        function getSignFileItemContent(idFileContainer, idFileItem, image, info, params) {
            var url = URL.URL + "/api/signature/docs/" + idFileContainer + "/" + idFileItem + "/sign/content";

            var formData = new FormData();
            formData.append('sig', image);
            formData.append('details', JSON.stringify(info));
            formData.append('signparams', JSON.stringify(params));

            return $q(function (resolve, reject) {
                $http.post(url, formData, {
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined }
                }).then(
                    function (result) {
                        resolve(result);
                    },
                    function (error) {
                        $log.error("Cannot sign file item");
                        console.dir(error);
                        reject(undefined);
                    });
            });
        }

        /**
        * Queries for information about a doc's signature
        * @param {int} idBox id of the box
        * @param {int} idItemBox id of the item box
        * @returns {Promise} doc's signature information
        */
        function itemBoxSignatureInfo(idBox, idItemBox) {
            var url = URL.URL + "/api/signature/box/" + idBox + "/" + idItemBox + "/signature_info";

            return $q(function (resolve, reject) {
                $http.get(url).success(function (result) {
                    resolve(result);
                }).error(function (error) {
                    $log.error("Cannot get item box signature info");
                    console.dir(error);
                    reject(error || undefined);
                });
            });
        }

        /**
        * Queries for information about a doc's signature
        * @param {int} idFileContainer id of the box
        * @param {int} idFileItem id of the item box
        * @returns {Promise} doc's signature information
        */
        function fileItemSignatureInfo(idFileContainer, idFileItem) {
            var url = URL.URL + "/api/signature/docs/" + idFileContainer + "/" + idFileItem + "/signature_info";

            return $q(function (resolve, reject) {
                $http.get(url).success(function (result) {
                    resolve(result);
                }).error(function (error) {
                    $log.error("Cannot get file item signature info");
                    console.dir(error);
                    reject(error || undefined);
                });
            });
        }
    }

    signatureService.$inject = ["$http", "$q", "$log", "URL"];
    angular.module("solpheo").service("solpheo.signatureService", signatureService);
})();
